import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconFilterComponent } from "./med-icon-filter.component";

@NgModule({
  declarations: [
    MedIconFilterComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconFilterComponent,
  ],
})
export class MedIconFilterModule { }
